import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useField } from 'formik'

import Label from './Label'
import { ReactSliderThumb, ReactSliderTrack, StyledSlider as Slider } from 'atoms/StyledSlider'

const StyledSlider = styled(Slider)`
  margin-top: 1.5rem;
`
const StyledRangeFieldContainer = styled.div`
  display: grid;
  grid-row-gap: 5px;
`

type RangeFieldProps = {
  label?: string
  valueLabel?: string
  name: string
  unit?: string
  min?: any
  max?: any
  step?: any
}

const RangeField = ({ label, valueLabel, name, unit, ...props }: RangeFieldProps) => {
  const [, meta, helpers] = useField(name)

  const { value }: { value: number | readonly number[] } = meta
  const { setValue } = helpers

  return (
    <StyledRangeFieldContainer>
      <Label color="black">{label}</Label>
      {unit && (
        <Label color="black" weight={400}>
          {valueLabel} {value}
          {unit}
        </Label>
      )}
      <StyledSlider
        className="mt-3"
        orientation="horizontal"
        value={value}
        onChange={(newValue) => setValue(newValue)}
        renderTrack={ReactSliderTrack}
        renderThumb={ReactSliderThumb}
        {...props}
      />
    </StyledRangeFieldContainer>
  )
}

RangeField.propTypes = {
  label: PropTypes.string,
  valueLabel: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  unit: PropTypes.string,
  value: PropTypes.string,
}

export default RangeField
